<template>
	<div>
		<table class="table table-borderless" :class="{ correct: !isRunning }" style="background-color: #64dd1720;">
			<tbody>
				<tr>
					<td class="p-0"></td>
					<td class="p-0"></td>
					<td class="tinyHeader col-3">{{ $t('text_photosynthesis') }}</td>
					<td class="p-0"></td>
					<td class="tinyHeader col-3">{{ $t('text_cellular_respiration') }}</td>
					<td class="p-0"></td>
					<td class="p-0"></td>
				</tr>
				<tr>
					<td class="text-end">
						<b>{{ $t('text_net_land') }}</b>
					</td>
					<td class="sign">=</td>
					<td>
						<div class="input-group" :class="{
							incorrect: answer[0] == incorrect[0],
							highlight: effect[0],
							malformed: !isValidNumber(answer[0])
						}">
							<input type="text" class="form-control" :disabled="!isRunning" v-model="answer[0]">
							<span class="input-group-text">{{ $t('unit_pgc_year') }}</span>
							<div v-if="answer[0] == incorrect[0]" class="incorrect-bubble" style="z-index: 9;"></div>
						</div>
					</td>
					<td class="sign">-</td>
					<td>
						<div class="input-group" :class="{
							incorrect: answer[1] == incorrect[1],
							highlight: effect[1],
							malformed: !isValidNumber(answer[1])
						}">
							<input type="text" class="form-control" :disabled="!isRunning" v-model="answer[1]">
							<span class="input-group-text">{{ $t('unit_pgc_year') }}</span>
							<div v-if="answer[1] == incorrect[1]" class="incorrect-bubble" style="z-index: 9;"></div>
						</div>
					</td>
					<td class="sign">=</td>
					<td class="sum" style="width: 20%;">
						{{ firstSum }}
						<small class="text-muted">{{ $t('unit_pgc_year') }}</small>
					</td>
				</tr>
				<tr>
					<td class="p-0"></td>
					<td class="p-0"></td>
					<td class="p-0"></td>
					<td class="p-0"></td>
					<td class="text-end">{{ $t('m3t4_label_land') }}</td>
					<td class="p-0"></td>
					<td>
						<div class="input-group" :class="{ incorrect: answer[2] == incorrect[2], highlight: effect[2] }">
							<select class="form-select" v-model="answer[2]" :disabled="!isRunning">
								<option value="" selected></option>
								<option value="sink">{{ $t('m3t4_label_sink') }}</option>
								<option value="source">{{ $t('m3t4_label_source') }}</option>
							</select>
							<div v-if="answer[2] == incorrect[2]" class="incorrect-bubble" style="z-index: 9;"></div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<table class="table table-borderless border" :class="{ correct: !isRunning }" style="background-color: #0091ea20;">
			<tbody>
				<tr>
					<td class="p-0"></td>
					<td class="p-0"></td>
					<td class="tinyHeader col-3">{{ $t('text_atmosphere_to_ocean') }}</td>
					<td class="p-0"></td>
					<td class="tinyHeader col-3">{{ $t('text_ocean_to_atmosphere') }}</td>
					<td class="p-0"></td>
					<td class="p-0"></td>
				</tr>
				<tr>
					<td class="text-end">
						<b>{{ $t('text_net_ocean') }}</b>
					</td>
					<td class="sign">=</td>
					<td>
						<div class="input-group" :class="{
							incorrect: answer[3] == incorrect[3],
							highlight: effect[3],
							malformed: !isValidNumber(answer[3])
						}">
							<input type="text" class="form-control" :disabled="!isRunning" v-model="answer[3]">
							<span class="input-group-text">{{ $t('unit_pgc_year') }}</span>
							<div v-if="answer[3] == incorrect[3]" class="incorrect-bubble" style="z-index: 9;"></div>
						</div>
					</td>
					<td class="sign">-</td>
					<td>
						<div class="input-group" :class="{
							incorrect: answer[4] == incorrect[4],
							highlight: effect[4],
							malformed: !isValidNumber(answer[4])
						}">
							<input type="text" class="form-control" :disabled="!isRunning" v-model="answer[4]">
							<span class="input-group-text">{{ $t('unit_pgc_year') }}</span>
							<div v-if="answer[4] == incorrect[4]" class="incorrect-bubble" style="z-index: 9;"></div>
						</div>
					</td>
					<td class="sign">=</td>
					<td class="sum" style="width: 20%;">
						{{ secondSum }}
						<small class="text-muted">{{ $t('unit_pgc_year') }}</small>
					</td>
				</tr>
				<tr>
					<td class="p-0"></td>
					<td class="p-0"></td>
					<td class="p-0"></td>
					<td class="p-0"></td>
					<td class="text-end">{{ $t('m3t4_label_ocean') }}</td>
					<td class="p-0"></td>
					<td>
						<div class="input-group" :class="{ incorrect: answer[5] == incorrect[5], highlight: effect[5] }">
							<select class="form-select" v-model="answer[5]" :disabled="!isRunning">
								<option value="" selected></option>
								<option value="sink">{{ $t('m3t4_label_sink') }}</option>
								<option value="source">{{ $t('m3t4_label_source') }}</option>
							</select>
							<div v-if="answer[5] == incorrect[5]" class="incorrect-bubble" style="z-index: 9;"></div>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<!-- Verify button -->
		<p v-if="isRunning" class="verify-button">
			<b class="btn progress-bar-striped"
				:class="{ 'btn-primary': allowVerify, 'btn-secondary': !allowVerify, 'progress-bar-animated': allowVerify }"
				@click="onVerify" :disabled="!allowVerify">
				{{ $t('quiz_button_verify') }}
			</b>
		</p>
	</div>
</template>



<script>
import TaskBox from './TaskBox.vue';

export default {
	mixins: [TaskBox],
	data() {
		return {
			answer: [
				'', '', '',
				'', '', '',
				// 142, 136.7, 'sink',
				// 79.5, 77.6, 'sink',
			],
			correct: [
				142, 136.7, 'sink',
				79.5, 77.6, 'sink',
			],
			correctRange: [
				[142, 142], [136.7, 137], ['sink', 'sink'],
				[79.5, 80], [77.6, 78], ['sink', 'sink'],
			],
			incorrect: [
				null, null, null,
				null, null, null,
			],
			effect: [
				false, false, false,
				false, false, false,
			],
			timeout: null,
		};
	},
	methods: {
		onAutoSlotClick(slotId, engaged) {
			for (let i = 0; i < this.effect.length; i++) {
				this.effect[i] = false;
			}

			const slots = ["button_photosynthesis", "button_respiration", null, "button_to_ocean", "button_to_atmosphere", null];
			const index = slots.indexOf(slotId);

			if (index != -1) {
				if (!this.$tracker.isHard()) {
					this.$set(this.effect, index, engaged);
				}
				if (this.$tracker.isEasy()) {
					this.$set(this.answer, index, this.correct[index]);
				}
			}
		}
	},
	computed: {
		firstSum() {
			let a = this.toNumber(this.answer[0]);
			let b = this.toNumber(this.answer[1]);
			let sum = (a - b).toFixed(1);
			return isNaN(sum) ? "..." : sum;
		},
		secondSum() {
			let a = this.toNumber(this.answer[3]);
			let b = this.toNumber(this.answer[4]);
			let sum = (a - b).toFixed(1);
			return isNaN(sum) ? "..." : sum;
		},
	}
};
</script>



<style scoped src="./numberFree.css"></style>
